import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/choose-client.css';

interface Props {
  /** i18n key for the page's name, e.g. 'nav.conversions'. */
  pageKey?: string;
  /** The page's name already in the interface language (for names we don't translate). */
  pageName?: string;
  /** Override the heading (default "Choose a Client"). */
  title?: string;
  /** Override the body text. */
  text?: React.ReactNode;
  /** Hide the "Choose a Client" CTA (e.g. when the issue isn't client selection). */
  hideButton?: boolean;
}

const ChooseClientPlaceholder: React.FC<Props> = ({ pageKey, pageName, title, text, hideButton }) => {
  const { t } = useTranslation();
  const [highlighting, setHighlighting] = useState(false);

  const handleChoose = () => {
    setHighlighting(true);
    document.body.classList.add('client-highlight-active');
    const switcher = document.querySelector('.client-nav-item') as HTMLButtonElement;
    if (switcher) switcher.click();
  };

  const stopHighlighting = () => {
    setHighlighting(false);
    document.body.classList.remove('client-highlight-active');
  };

  useEffect(() => {
    if (!highlighting) return;
    const handler = () => {
      setTimeout(() => {
        const dropdown = document.querySelector('.client-dropdown');
        if (!dropdown) stopHighlighting();
      }, 100);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [highlighting]);

  useEffect(() => {
    return () => document.body.classList.remove('client-highlight-active');
  }, []);

  return (
    <div className="choose-client-placeholder">
      <div className="choose-client-orb">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="url(#wg)" strokeWidth="1.5"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="url(#wg)" strokeWidth="1.8"/>
          <circle cx="12" cy="16.5" r="0.8" fill="url(#wg)"/>
          <defs>
            <linearGradient id="wg" x1="2" y1="3" x2="22" y2="21" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FF6B4A"/>
              <stop offset="0.5" stopColor="#E94B6C"/>
              <stop offset="1" stopColor="#8E3A9A"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <h3 className="choose-client-title">{title || t('common.chooseClient')}</h3>
      <p className="choose-client-text">
        {text || t('common.chooseClientText', {
          page: pageKey ? t(pageKey) : (pageName || t('common.thisPage')),
        })}
      </p>
      {!hideButton && (
        <button className="choose-client-btn" onClick={handleChoose}>
          {t('common.chooseClient')}
        </button>
      )}
    </div>
  );
};

export default ChooseClientPlaceholder;
